import axios from 'axios';
import SearchRequest from '@/requests/SearchRequest';
import SearchResponse from '@/requests/SearchResponse';
import { PATH_SEARCH } from '@/paths';
import FilterOption from '@/models/FilterOption';
import QueryString from 'qs';
import SearchRequestParams from '@/requests/SearchRequestParams';

export default class SearchService {
  public static async doSearch(data: SearchRequest): Promise<SearchResponse> {
    return new Promise<SearchResponse>((resolve, reject) => {
      axios.get(`${PATH_SEARCH + data.country}/search/api`, {
        params: SearchService.transformRequest(data),
        paramsSerializer: SearchService.parameterSerializer,
      })
        .then((response) => {
          resolve(response.data as SearchResponse);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async doSearchGrouped(data: SearchRequest): Promise<SearchResponse> {
    return new Promise<SearchResponse>((resolve, reject) => {
      axios.get(`${PATH_SEARCH + data.country}/search/api/grouped`, {
        params: SearchService.transformRequest(data),
        paramsSerializer: SearchService.parameterSerializer,
      })
        .then((response) => {
          resolve(response.data as SearchResponse);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static parameterSerializer(params: SearchRequestParams): string {
    return QueryString.stringify(params, { arrayFormat: 'brackets' });
  }

  private static transformRequest(data: SearchRequest): {
    country: string;
    searchTerm: string;
    limitP: number | undefined;
    offset: number;
    limit: number;
    filters: { [p: string]: { [p: string]: string } };
    strictSearch: number;
    locale: string;
    type: string;
    limitE: number | undefined;
    limitC: number | undefined;
  } {
    const filters: {
      [name: string]: {
        [name: string]: string;
      };
    } = {};
    data.filters.forEach((filterOption: FilterOption) => {
      if (!filters[filterOption.filterId]) {
        filters[filterOption.filterId] = {};
      }
      filters[filterOption.filterId][filterOption.id] = filterOption.id;
    });
    const returnObject = {
      searchTerm: data.searchTerm,
      offset: data.offset,
      limit: data.limit,
      locale: data.locale.toString(),
      type: data.type.toString(),
      country: data.country.toString(),
      filters,
      strictSearch: data.strictSearch,
      limitP: data.limitP,
      limitE: data.limitE,
      limitC: data.limitC,
    };

    if (data.filters.size === 0) {
      delete returnObject.filters;
    }

    return returnObject;
  }
}
